import {Component, Input, OnDestroy} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {TranslatePipe} from '@ngx-translate/core';
import {DocumentHal} from '../../../models/HAL/document-hal.model';
import {FormActionsHelperService} from '../../../services/form-actions-helper.service';
import {Router} from '@angular/router';
import {PostMessageSubscribeTypeEnum} from '../../../enums/post-message-subscribe-type.enum';
import {PostMessageSubscriberService} from '../../../services/post-message-subscriber.service';
import {LoadingSpinnerService} from '../../../services/loading-spinner.service';
import {SnackBarService} from '../../../services/snackbar.service';

@Component({
  selector: 'app-collaborator-preview-form-metadata',
  imports: [
    MatIcon,
    MatIconButton,
    TranslatePipe,
    MatButton
  ],
  templateUrl: './collaborator-preview-form-metadata.component.html',
  styleUrl: './collaborator-preview-form-metadata.component.scss'
})
export class CollaboratorPreviewFormMetadataComponent implements OnDestroy {

  @Input()
  documentHal: DocumentHal | undefined;

  constructor(public readonly formActionsHelperService: FormActionsHelperService,
              private readonly postMessageSubscriberService: PostMessageSubscriberService,
              private readonly loadingSpinnerService: LoadingSpinnerService,
              private readonly snackBarService: SnackBarService,
              private readonly router: Router) {
    this.subscribeToDataCapturing();
    this.subscribeToSaveProgress();
  }

  ngOnDestroy() {
    this.postMessageSubscriberService.unsubscribe(PostMessageSubscribeTypeEnum.DATA_CAPTURING);
    this.postMessageSubscriberService.unsubscribe(PostMessageSubscribeTypeEnum.SAVE_PROGRESS);
  }

  backToCollaboratorView() {
    this.router.navigate([this.documentHal?._links.getLink('case')?.getRoute()]).then();

  }

  private subscribeToSaveProgress() {
    this.postMessageSubscriberService.subscribe(PostMessageSubscribeTypeEnum.SAVE_PROGRESS, (data) => {
      if (data?.state === "COMPLETE") {
        this.loadingSpinnerService.hide();
        this.backToCaseView();
        this.snackBarService.open("previewForm.saveProgressCompleted", 3);
      } else {
        this.loadingSpinnerService.hide();
        this.snackBarService.open("previewForm.saveProgressNotCompleted", 3, "error");
      }
    });
  }

  private subscribeToDataCapturing() {
    this.postMessageSubscriberService.subscribe(PostMessageSubscribeTypeEnum.DATA_CAPTURING, (data) => {
      if (data?.state === "COMPLETE") {
        this.loadingSpinnerService.hide();
        this.backToCaseView();
        this.snackBarService.open("previewForm.dataCapturingCompleted", 3);
      }
      if (data?.state === "NOT_COMPLETE") {
        this.loadingSpinnerService.hide();
        this.snackBarService.open("previewForm.dataCapturingNotCompleted", 3, "error");
      }
    });
  }

  protected backToCaseView() {
    this.router.navigate([new DocumentHal(this.documentHal)._links.getLink('case')?.getRoute()]).then();
  }

}
